export default __webpack_public_path__ + "static/media/p59.903cc29f.jpg";